import { FC, PropsWithChildren } from 'react'

import { UniqueIdentifier } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

type Props = {
  id: UniqueIdentifier
}

export const CommonContentsAssetSortItem: FC<PropsWithChildren<Props>> = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })

  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className="tw-outline-none"
      {...attributes}
      {...listeners}
    >
      {children}
    </div>
  )
}
